import ApiPostOptions from '@/datatypes/api-post-options';
import ApiService from '@/services/api/ApiService';

export default class RecipientService extends ApiService {
  public reset(recipient) {
    return this.call(new ApiPostOptions(
      {
        url: `/recipients/${recipient.id}/reset`,
        params: {},
      },
    ));
  }
}
